// Canonical site identity. Update SITE_URL if the production domain changes.
// NOTE: this must be the domain users actually visit (the frontend), NOT the
// backend API host. Kept in one place so canonical/OG tags never drift again.
export const SITE_URL = 'https://www.koicreate.com';
export const SITE_NAME = 'KoiCreate';
export const SITE_OG_IMAGE = '/assets/KoiShareableLogo.jpg';
